const FilterType = {
	// Text Input field for typing filtering text
	INPUT: 'input',
	// Select menu with predefined or auto-generated options
	SELECT: 'select',
	// Select menu allowing multiple selections
	SELECT_MULTI: 'select-multi',
	// From/To date range filtering
	DATE_RANGE: 'date-range',
};

export default FilterType;

export function filterIsSelect(filterType) {
	return [FilterType.SELECT, FilterType.SELECT_MULTI].includes(filterType);
}
